// extracted by mini-css-extract-plugin
export default {"cardContainer":"dashboard_file_report_card__cardContainer--9S-J","cardContent":"dashboard_file_report_card__cardContent--Oywb"};